import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "50px",
    marginBottom: "100px",
  },
  container: {
    padding: "10px",
    borderRadius: "10px",
    // marginBottom: "30px",
  },
  wrapKategori: {
    justifyContent: "center",
  },
  wrapper: {
    paddingLeft: 4,
    paddingRight: 4,
    marginBottom: 15,
    // "@media(min-width: 280px)": {
    //   width: "calc(100%/2)",
    //   height: "100%",
    // },
    // "@media(min-width: 320px)": {
    //   width: "calc(100%/2)",
    //   height: "100%",
    // },
    // "@media(min-width: 360px)": {
    //   width: "calc(100%/2)",
    //   height: "100%",
    // },
    // "@media(min-width: 400px)": {
    //   width: "calc(100%/2)",
    //   height: "100%",
    // },
    // "@media(min-width: 600px)": {
    //   width: "calc(100%/3)",
    //   height: "100%",
    // },
    // "@media(min-width: 960px)": {
    //   width: "calc(100%/4)",
    //   height: "100%",
    // },
  },
  card: {
    height: "100%",
    borderRadius: 5,
  },
  img: {
    width: 155,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    borderRadius: 5,
    "@media(min-width: 280px)": {
      width: 100,
      height: 128,
    },
    "@media(min-width: 320px)": {
      width: 100,
      height: 148,
    },
    "@media(min-width: 360px)": {
      width: 100,
      height: 168,
    },
    "@media(min-width: 960px)": {
      width: 155,
      height: 230,
    },

    [theme.breakpoints.down("600")]: {
      height: "300",
    },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "0px 15px",
    marginTop: 8,
  },
  title: {
    fontWeight: 700,
    fontSize: 14,
    textAlign: "center",
    color: "#333333",
    maxWidth: "100%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "@media(min-width: 280px)": {
      fontSize: 12,
    },
    "@media(min-width: 320px)": {
      fontSize: 12,
    },
    "@media(min-width: 360px)": {
      fontSize: 14,
    },
    "@media(min-width: 960px)": {
      fontSize: 14,
    },
  },
  price: {
    fontWeight: 700,
    fontSize: 12,
    color: "#eb6669",
    textAlign: "center",
    maxWidth: 139,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "@media(max-width: 280px)": {
      width: 100,
    },
    "@media(min-width: 960px)": {
      maxWidth: 150,
    },
  },
  btnWrap: {
    margin: 8,
    marginBottom: 12,
  },
  btn: {
    color: "#ffff",
    fontWeight: 700,
    fontSize: 12,
    "@media(max-width: 280px)": {
      padding: "4px 4px",
    },
    textTransform: "capitalize",
  },
  empty: {
    backgroundColor: "hsla(0,0%,100%,.9)",
    width: "100%",
    height: "100%",
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  txtEmpty: {
    fontSize: 18,
    fontWeight: 700,
    color: "rgba(0,0,0,.4)",
  },
  wrapScroll: {
    display: "flex",
    overflowX: "auto",
    flexWrap: "nowrap",
  },
}));

export default useStyles;
